module Meevo.Plugins.AlertsManager {

    import IAlertJSON = Meevo.Model.IAlertJSON;
    import ComparisonTypeEnum = Meevo.Model.ComparisonTypeEnum;

    interface IRatingIsSubmittedAlertJson extends IAlertJSON {
        comparisonType: ComparisonTypeEnum;
        value: number;
    }

    class MeevoAlertManagerRatingIsSubmittedConfigComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
            '$translate'
        ];

        public params: IParams;
        public data: ISingleMoverData;

        public comparisonTypeModel: ComparisonTypeEnum = ComparisonTypeEnum.IsEqualOrHigherThan;
        public starsModel: number = 5;
        public displayClientNameModel: boolean = true;
        public comparisonTypes = [];

        public get dataForReview() {
            let data = [];
            switch (this.comparisonTypeModel) {
                case ComparisonTypeEnum.IsEqualOrHigherThan:
                    data.push(this.$translate.instant('LABEL_RATING_EQUAL_TO_OR_HIGHER', {value: this.starsModel}));
                    break;
                case ComparisonTypeEnum.IsEqualOrLowerThan:
                    data.push(this.$translate.instant('LABEL_RATING_EQUAL_TO_OR_LOWER', {value: this.starsModel}));
                    break;
                case ComparisonTypeEnum.IsEqualTo:
                    data.push(this.$translate.instant('LABEL_RATING_EQUAL_TO', {value: this.starsModel}));
                    break;
            }
            data.push(`${this.$translate.instant('LABEL_DISPLAY_CLIENT_NAME_IN_ALERT')}: ${this.$translate.instant(this.displayClientNameModel ? 'LABEL_YES' : 'LABEL_NO')}`)

            return data;
        }

        public get alertConfiguration() {
            return {
                comparisonType: this.comparisonTypeModel,
                value: +this.starsModel,
                displayClientName: this.displayClientNameModel
            };
        }


        constructor(protected alertsManagerService: IAlertsManagerService,
                    protected $translate: ng.translate.ITranslateService) {
            super(alertsManagerService);

            this.comparisonTypes = [
                {
                    value: ComparisonTypeEnum.IsEqualOrHigherThan,
                    label: this.$translate.instant('LABEL_RATING_EQUAL_TO_OR_HIGHER', {value: 'X'})
                },
                {
                    value: ComparisonTypeEnum.IsEqualOrLowerThan,
                    label: this.$translate.instant('LABEL_RATING_EQUAL_TO_OR_LOWER', {value: 'X'})
                },
                {
                    value: ComparisonTypeEnum.IsEqualTo,
                    label: this.$translate.instant('LABEL_RATING_EQUAL_TO', {value: 'X'})
                },
            ];
        }

        public onEdit(alertJSON: IRatingIsSubmittedAlertJson): void {
            this.comparisonTypeModel = alertJSON['comparisonType'];
            this.starsModel = +alertJSON['value'];
            this.displayClientNameModel = alertJSON['displayClientName'];
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoAlertManagerRatingIsSubmittedConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/rating-is-submitted-config/rating-is-submitted-config.component.html',
            controller: MeevoAlertManagerRatingIsSubmittedConfigComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<'
            }
        });
}
